<template>
  <v-layout wrap justify-left align-center>
    <v-dialog v-model="dialogExportLCDPR" persistent scrollable max-width="600">
      <v-card>
        <v-card-title primary-title>
          <span class="display-1">Gerar LCDPR</span>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-form @keyup.native.esc="close" @keyup.native.enter="confirm()">
              <v-flex xs12>
                <v-autocomplete
                  :items="condominiosPessoa"
                  v-model="editedItem.condominios_ids"
                  label="Condominios"
                  multiple
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="[{value: 0,text:'Regular(Início no primeiro dia do ano)'},{value:1 ,text:'Abertura (Início de atividades no ano-calendário)'},{value:2 ,text:'Inicio de obrigatoriedade da escritura no curso do ano calendário'}]"
                  v-model="editedItem.ind_sit_ini_per"
                  label="Indicador de Início do Período"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="[{value:0,text:'Normal'},{value:1,text:'Falecimento'},{value:2,text:'Espólio'},{value:3,text:'Saída definitica do País'}]"
                  v-model="editedItem.sit_especial"
                  label="Indicador de Situação Especial e Outros Eventos"
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="editedItem.sit_especial !== 0">
                <p-date label="Data da Situação Especial" v-model="editedItem.dt_sit_esp"></p-date>
              </v-flex>
              <v-flex xs12>
                <p-date 
                  required
                  name="dt_ini"
                  :error-messages="errors.collect('dt_ini')"
                  v-validate="'required'"
                  data-vv-as="Data do Início"
                  label="Data do Início do Período" v-model="editedItem.dt_ini">
                </p-date>
              </v-flex>
              <v-flex xs12>
                <p-date
                  name="dt_fin"
                  :error-messages="errors.collect('dt_fin')"
                  v-validate="'required'"
                  data-vv-as="Data do Fim"
                  label="Data do Início do Período" v-model="editedItem.dt_fin">
                </p-date>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="[{value:1,text:'Livro Caixa'},{value:2,text:'Apuração do lucro pelo disposto no art. 5º da Lei nº 8.023, de 1990'}]"
                  v-model="editedItem.forma_apur"
                  label="Indicador de Situação Especial e Outros Eventos"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.ident_nom"
                  label="Nome contador"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.ident_cpf_cnpj"
                  label="cpf/cnpj do contador"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.ind_crc"
                  label="Número de inscrição do contador"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.email"
                  label="email do contador"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.fone"
                  label="Telefone do contador"
                ></v-text-field>
              </v-flex>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confirm">Confirmar</v-btn>
          <v-btn color="green darken-1" flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
</style>
<script>
  import PDate from '../shared/PDate'

  export default {
    name: 'PExportLCDPR',
    components: {PDate},
    data () {
      return {
        // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
        condominiosPessoa: [],
        dialogExportLCDPR: false,
        editedItem: {pessoa_id: '', nome: '', ind_sit_ini_per: 0, sit_especial: 0, dt_sit_esp: '', dt_ini: `${this.$auth.user().anobase.id_texto}-01-01`, dt_fin: `${this.$auth.user().anobase.id_texto}-12-31`, forma_apur: 1, ident_nom: '', ident_cpf_cnpj: '', ind_crc: '', email: '', fone: '', condominios_ids: []}
      }
    },
    methods: {
      confirm () {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'error',
              dialog: true
            })
          } else {
            this.$store.commit('loader/change_dialog', true)
            this.$http.post(`export/lcdpr`, this.editedItem, {responseType: 'arraybuffer'}).then(res => {
              let blob = new Blob([res.data], {type: res.headers.get('content-type')})
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = `LCDPR-${this.editedItem['nome']}-${this.$auth.user().anobase.id_texto + 1}-${parseInt(this.$auth.user().anobase.id_texto)}.TXT`
              link.click()
              // Detecta arquivo de erros lendo o início do conteúdo (evita depender de header customizado/CORS)
              const inicio = new TextDecoder('utf-8').decode(new Uint8Array(res.data).slice(0, 60))
              if (inicio.indexOf('Ocorreu alguns erros') === 0) {
                const mensagemErro = 'Ocorreram erros ao gerar o LCDPR. Abra o arquivo baixado para visualizar os erros e corrigi-los.'
                this.$store.commit('snackbar/change_values', {
                  text: mensagemErro,
                  color: 'error',
                  dialog: true,
                  timeout: 15000
                })
                window.alert(mensagemErro)
              }
              this.$store.commit('loader/change_dialog', false)
            }, () => this.$store.commit('loader/change_dialog', false)
            )
          }
        })
      },
      // confirm: function () {
      //   console.log('confirm')
      // },
      close: function () {
        this.dialogExportLCDPR = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PExportLCDPR.vue